export const TENANT_ROUTE_PREFIX = "/tenant/" as const;
export const TENANT_HEADER_NAME = "CurrentTenantId" as const;

export type TenantRouteParams = {
  tenantId?: string;
};

/**
 * Extrait le tenantId depuis un pathname de type /tenant/:tenantId/...
 * Retourne null si on n'est pas sur une route tenant-scoped.
 */
export const parseTenantIdFromPathname = (pathname: string): string | null => {
  if (!pathname.startsWith(TENANT_ROUTE_PREFIX)) return null;

  // pathname: /tenant/{id}/...
  const rest = pathname.slice(TENANT_ROUTE_PREFIX.length);
  const tenantId = rest.split("/")[0];

  return tenantId ? decodeURIComponent(tenantId) : null;
};

/**
 * Variante pratique pour les environnements navigateur.
 * (À éviter en SSR : window n'existe pas.)
 */
export const getTenantIdFromWindowLocation = (): string | null => {
  return parseTenantIdFromPathname(window.location.pathname);
};
